<template>
<div class="bg-white h-screen flex flex-col">
    <Header :cart="cart" :cartAnimation="cartAnimation" @refresh-cart="$emit('refresh-cart', $event)" :show-cart="showCart" />
    <section class="flex flex-col flex-grow items-center justify-center font-mono text-gray-600 bg-white">
        <div class="container mx-auto min-h-36 md:min-h-96">
            <slot/>
        </div>
    </section>
    <Footer class="w-full flex-shrink"/>
</div>
</template>

<script>
import Header from '../components/Header';
import Footer from '../components/Footer';

export default {
    name: "Layout",
    props: {
        showCart: {
            default: false
        }
    },
    components: {
        Header,
        Footer
    },
    data: function () {
        return {
            cart: null,
            cartAnimation: false,
        }
    },
};
</script>
